/**
 * 사이드바 네비게이션 섹션 컴포넌트 - HeroUI 버전
 */ import React from 'react';
import { Button, Tooltip, cn } from '@heroui/react';
import { motion, AnimatePresence } from 'framer-motion';
import { MAIN_LAYOUT_TEST_IDS } from '@edusense/shared-constants';
export const NavigationSectionHeroUI = ({ navigationItems, activeMenu, onMenuClick, isTabletView, isMobileSidebar, isIconOnlyMode })=>{
    const handleMenuItemClick = (itemId)=>{
        if (onMenuClick) {
            onMenuClick(itemId);
        }
    };
    // 네비게이션 아이템 ID를 testid로 매핑하는 함수
    const getNavTestId = (itemId)=>{
        switch(itemId){
            case 'home':
                return MAIN_LAYOUT_TEST_IDS.NAV_FEED;
            case 'courses':
                return MAIN_LAYOUT_TEST_IDS.NAV_LEARN;
            case 'about':
                return MAIN_LAYOUT_TEST_IDS.NAV_DISCOVER;
            case 'profile':
                return MAIN_LAYOUT_TEST_IDS.NAV_PROFILE;
            case 'settings':
                return MAIN_LAYOUT_TEST_IDS.NAV_SETTINGS;
            default:
                return `nav-${itemId}`;
        }
    };
    const navVariants = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: (i)=>({
                opacity: 1,
                y: 0,
                transition: {
                    delay: i * 0.05,
                    duration: 0.3,
                    type: "spring",
                    stiffness: 260,
                    damping: 20
                }
            })
    };
    const iconVariants = {
        inactive: {
            scale: 1,
            rotate: 0
        },
        active: {
            scale: 1.1,
            rotate: [
                0,
                -5,
                5,
                0
            ],
            transition: {
                rotate: {
                    duration: 0.3,
                    times: [
                        0,
                        0.33,
                        0.66,
                        1
                    ]
                },
                scale: {
                    duration: 0.2
                }
            }
        }
    };
    const isCompact = typeof isIconOnlyMode === 'boolean' ? isIconOnlyMode : isTabletView;
    const getButtonContent = (item)=>{
        const iconElement = /*#__PURE__*/ React.createElement(motion.div, {
            variants: iconVariants,
            initial: "inactive",
            animate: activeMenu === item.id ? "active" : "inactive",
            className: cn("flex items-center justify-center transition-all", activeMenu === item.id && "text-primary-foreground")
        }, item.icon);
        if (isMobileSidebar) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "flex items-center gap-3 w-full"
            }, iconElement, /*#__PURE__*/ React.createElement("span", {
                className: "font-medium"
            }, item.label));
        }
        if (!isCompact) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "flex items-center justify-between gap-3 w-full"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "font-medium"
            }, item.label), iconElement);
        }
        return iconElement;
    };
    const renderNavButton = (item)=>{
        const button = /*#__PURE__*/ React.createElement(Button, {
            key: item.id,
            onPress: ()=>handleMenuItemClick(item.id),
            "data-testid": getNavTestId(item.id),
            variant: activeMenu === item.id ? "shadow" : "light",
            color: activeMenu === item.id ? "primary" : "default",
            size: isCompact ? "sm" : "md",
            className: cn("transition-all duration-200", isMobileSidebar ? "w-full justify-start" : isCompact ? "min-w-0" : "min-w-[200px]", !isMobileSidebar && !isCompact && "justify-end", activeMenu === item.id && "shadow-lg shadow-primary/30"),
            startContent: isMobileSidebar ? undefined : !isCompact ? undefined : null,
            endContent: !isMobileSidebar && !isCompact ? undefined : null
        }, getButtonContent(item));
        // 태블릿 뷰에서만 툴팁 표시
        if (isCompact && !isMobileSidebar) {
            return /*#__PURE__*/ React.createElement(Tooltip, {
                key: item.id,
                content: item.label,
                placement: "right",
                showArrow: true,
                delay: 0,
                closeDelay: 0,
                className: "font-medium",
                classNames: {
                    content: "bg-default-900 text-default-50"
                }
            }, button);
        }
        return button;
    };
    return /*#__PURE__*/ React.createElement("nav", {
        className: cn("w-full flex flex-col", isMobileSidebar ? "items-start px-2" : isCompact ? "items-center" : "items-end")
    }, /*#__PURE__*/ React.createElement(AnimatePresence, {
        mode: "wait"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full space-y-2"
    }, navigationItems.map((item, index)=>/*#__PURE__*/ React.createElement(motion.div, {
            key: item.id,
            custom: index,
            variants: navVariants,
            initial: "hidden",
            animate: "visible",
            whileHover: {
                x: isMobileSidebar ? 4 : isCompact ? 0 : -4
            },
            className: "relative"
        }, renderNavButton(item), isCompact && !isMobileSidebar && activeMenu === item.id && /*#__PURE__*/ React.createElement(motion.div, {
            className: "absolute left-full top-1/2 ml-2",
            initial: {
                opacity: 0,
                scale: 0
            },
            animate: {
                opacity: 1,
                scale: 1
            },
            exit: {
                opacity: 0,
                scale: 0
            },
            transition: {
                duration: 0.2
            }
        }, /*#__PURE__*/ React.createElement("div", {
            className: "w-1 h-4 bg-primary rounded-full shadow-glow-primary"
        })), activeMenu !== item.id && /*#__PURE__*/ React.createElement(motion.div, {
            className: "absolute inset-0 rounded-lg bg-gradient-to-r from-transparent to-primary/5 opacity-0 hover:opacity-100 transition-opacity pointer-events-none",
            initial: {
                opacity: 0
            },
            whileHover: {
                opacity: 1
            }
        }))))));
};
export default NavigationSectionHeroUI;
